import Table from '../Table/index'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import _ from 'lodash'
import { filter } from 'rxjs/operators'
import loadingSVG from '../../media/loading.svg'
import EntryItem from '../EntryTypes2'

const LabDetails = (props) => {
  return (
    <div className='pv3 ph4 w-100 flex' style={{background: '#f5f3f5'}}>
      <div className='' style={{flexGrow: 2}}>
        <EntryItem _id={props.view?.details?.selected} _title='Code' _display={'text'} _type={'locations'} _large={true} _object={'code'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Name' _display={'text'} _type={'locations'} _large={true} _object={'name'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Attention' _display={'text'} _type={'locations'} _large={true} _object={'attention'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Phone' _display={'text'} _type={'locations'} _large={true} _object={'phone'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Email' _display={'text'} _type={'locations'} _large={true} _object={'email'} {...props}/>  
        {/* <EntryItem _id={props.view?.details?.selected} _title='EmailCC' _display={'text'} _type={'locations'} _large={true} _object={'emailCC'} {...props}/>   */}
        {/* <EntryItem _title='Referee Lab' _type={'select'}  _updateType={'lab'} _value={_.filter(props.locations, location => location.type==='LAB')?.map(type => ({value: type.id, label: type.code + ' - ' + type.name})) ?? [] } {...props}/> */}

      </div>
      <div className='' style={{flexGrow: 1}}>
      <EntryItem _id={props.view?.details?.selected} _title='Address' _display={'text'} _type={'locations'} _large={true} _object={'address'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='City' _display={'text'} _type={'locations'} _large={true} _object={'city'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='State' _display={'text'} _type={'locations'} _large={true} _object={'state'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Zip' _display={'text'} _type={'locations'} _large={true} _object={'zip'} {...props}/>   
     
      </div>
    </div>
  )
}

const IngredientDetails = (props) => {
  return (
    <div className='pv3 ph4 w-100 flex' style={{background: '#f5f3f5'}}>
      <div className='' style={{flexGrow: 2}}>
      <EntryItem 
          _id={props.view?.details?.selected} 
          _title='Shipment Type' 
          _display={'select'} 
          _type={'ingredients'} 
          _large={true} 
          _object={'shipmentType'} 
          _defaultValue={_.find(props.ingredients?.rawData, ingredient => ingredient.id === props.view?.details?.selected)?.sampleType?.id} 
          _fullOptions={props.shipmentTypes?.rawData} 
          _value={props.shipmentTypes?.rawData?.map(type => ({value: type.id, label: type.code + ' - ' + type.name})) ?? [] } {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Code' _display={'text'} _type={'ingredients'} _large={true} _object={'code'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Name' _display={'text'} _type={'ingredients'} _large={true} _object={'name'} {...props}/>  
        {/* <EntryItem _id={props.view?.details?.selected} _title='Attention' _display={'text'} _type={'ingredients2'} _large={true} _object={'attention'} {...props}/>   */}
        
      </div>
      <div className='' style={{flexGrow: 1}}>
        <EntryItem _id={props.view?.details?.selected} _title='Protein Claimable' _display={'text'} _type={'ingredients'} _large={false} _object={'proteinClaimable'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Fiber Claimable' _display={'text'} _type={'ingredients'} _large={false} _object={'fiberClaimable'} {...props}/>
        <EntryItem _id={props.view?.details?.selected} _title='Moisture Threshold' _display={'text'} _type={'ingredients'} _large={false} _object={'moistureThreshold'} {...props}/>
        <EntryItem _id={props.view?.details?.selected} _title='Protein Threshold' _display={'text'} _type={'ingredients'} _large={false} _object={'proteinThreshold'} {...props}/>
        <EntryItem _id={props.view?.details?.selected} _title='Fiber Threshold' _display={'text'} _type={'ingredients'} _large={false} _object={'fiberThreshold'} {...props}/>
      </div>
    </div>
  )
}

const ShipmentTypeDetails = (props) => {
  return (
    <div className='pv3 ph4 w-100 flex' style={{background: '#f5f3f5'}}>
      <div className='' style={{flexGrow: 2}}>
        <EntryItem _id={props.view?.details?.selected} _title='Code' _display={'text'} _type={'shipmentTypes'} _large={true} _object={'code'} {...props}/>  
        <EntryItem _id={props.view?.details?.selected} _title='Name' _display={'text'} _type={'shipmentTypes'} _large={true} _object={'name'} {...props}/>  

      </div>
      <div className='' style={{flexGrow: 1}}>
     
      </div>
    </div>
  )
}

const SaveHeader = (props) => {
  const selected = props.view?.details?.selected
  const locationType = props._locationType
  const type = props._type
  return (
    <div className='flex items-center'>
        {selected ? 
        <>
          <div className='pr3 white f6 pointer ' 
          onClick={e => {
            Dispatch.nextState('view.details.selected', null)
            Dispatch.nextAction('__.buffer.clearBuffer.' + type + '2')
          }}>Cancel</div>
          <SubmitButton id={'inc'} className='' 
              responseId='inc'
              defaultChild={ props => (
                <div className='ml2 pv2 ph3 bg-evonik-light-purple br2 white f6 fw5 pointer '
                  onClick={e => Dispatch.nextAction(type + '.save', {type:locationType})}
                >
                  Save
                </div>
              )}
              loadingChild={ props => (
                  <div className='mh3 ' style={{width:40, height: 30}}>
                    <img className='w-100 h-100' src={loadingSVG} alt='loading'/>
                  </div>
              )}
              errorChild={ props => (
                <div className='pl3 f7 fw4 red tr pointer'>Error</div>
              )}
              loadingStream={
                Dispatch.getAction('Request.' + type + '.save')
                  .pipe(
                  )
                }
              successStream={
                Dispatch.getAction('Response.' + type + '.save')
                  .pipe(
                    filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertLocations) || 
                      !_.isNil(e.data.upsertLocations) || 
                      !_.isNil(e.data.upsertIngredients) ||
                      !_.isNil(e.data.upsertShipmentTypes)
                    ))),
                  )
                }
              errorStream={
                Dispatch.getAction('Response.' + type + '.save')
                  .pipe(
                    filter(e => !_.isNil(e.errors)),
                  )}
            />
          </>
          :
          <div className='f6 white pointer '
                    onClick={e => Dispatch.nextState('view.details.selected', -1)}
          >Add New</div>
     }
    </div>
  )
}

const tables = {
  locations: {
    title: 'Origins',
    type: 'locations',
    locationType: 'ORIGIN',
    layout: [
      {
        field: 'code',
        header: 'Code',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'name',
        header: 'Name',
        type: 'text',
        style: 'ph2',
        fieldStyle: 'ph2',
        childClass: 'pointer underline',
        onClick: (e, props) => Dispatch.nextState('view.details.selected', props.id)
      },
      {
        field: 'city',
        header: 'City',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'state',
        header: 'State',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'email',
        header: 'Email',
        type: 'text',
        fieldStyle: 'ph2'
      },
      // {
      //   field: 'emailCC',
      //   header: 'EmailCC',
      //   type: 'text',
      //   fieldStyle: 'ph2'
      // },
    ],
    data: (props) => _.filter(props.locations?.rawData, data => data?.type === 'ORIGIN') ?? [],
    loading: (props) => props.locations?.loading ?? true,
    details: LabDetails,
    header: SaveHeader,
  },
  labs: {
      title: 'Referee Labs',
      type: 'locations',
      locationType: 'LAB',
      layout: [
        {
          field: 'code',
          header: 'Code',
          type: 'text',
          fieldStyle: 'ph2'
        },
        {
          field: 'name',
          header: 'Name',
          type: 'text',
          style: 'ph2',
          fieldStyle: 'ph2',
          childClass: 'pointer underline',
          onClick: (e, props) => Dispatch.nextState('view.details.selected', props.id)
        },
        {
          field: 'city',
          header: 'City',
          type: 'text',
          fieldStyle: 'ph2'
        },
        {
          field: 'state',
          header: 'State',
          type: 'text',
          fieldStyle: 'ph2'
        },
        {
          field: 'email',
          header: 'Email',
          type: 'text',
          fieldStyle: 'ph2'
        },
        // {
        //   field: 'emailCC',
        //   header: 'EmailCC',
        //   type: 'text',
        //   fieldStyle: 'ph2'
        // },
      ],
      data: (props) => _.filter(props.locations?.rawData, data => data?.type === 'LAB') ?? [],
      loading: (props) => props.locations?.loading ?? true,
      details: LabDetails,
      header: SaveHeader,
  },
  customers: {
    title: 'Customers',
    type: 'locations',
    locationType: 'CUSTOMER',
    layout: [
      {
        field: 'code',
        header: 'Code',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'name',
        header: 'Name',
        type: 'text',
        style: 'ph2',
        fieldStyle: 'ph2',
        childClass: 'pointer underline',
        onClick: (e, props) => Dispatch.nextState('view.details.selected', props.id)
      },
      {
        field: 'city',
        header: 'City',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'state',
        header: 'State',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'email',
        header: 'Email',
        type: 'text',
        fieldStyle: 'ph2'
      },
      // {
      //   field: 'emailCC',
      //   header: 'EmailCC',
      //   type: 'text',
      //   fieldStyle: 'ph2'
      // },
    ],
    data: (props) => _.filter(props.locations?.rawData, data => data?.type === 'CUSTOMER') ?? [],
    loading: (props) => props.locations?.loading ?? true,
    details: LabDetails,
    header: SaveHeader,
},
  ingredients: {
    title: 'Ingredients',
    //type: 'CUSTOMER',
    type: 'ingredients',
    layout: [
      {
        field: 'sampleType.name',
        header: 'Sample Type',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'code',
        header: 'Code',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'name',
        header: 'Name',
        type: 'text',
        style: 'ph2',
        fieldStyle: 'ph2',
        childClass: 'pointer underline',
        onClick: (e, props) => Dispatch.nextState('view.details.selected', props.id)
      },
      {
        field: 'proteinClaimable',
        header: 'Protein Claimable',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'fiberClaimable',
        header: 'Fiber Claimable',
        type: 'text',
        fieldStyle: 'ph2'
      },
     
    ],
    data: (props) => props.ingredients?.rawData ?? [],
    loading: (props) => props.ingredients?.loading ?? true,
    details: IngredientDetails,
    header: SaveHeader,
  },
  shipmentTypes: {
    title: 'Shipment Types',
    //type: 'CUSTOMER',
    type: 'shipmentTypes',
    layout: [
      {
        field: 'code',
        header: 'Code',
        type: 'text',
        fieldStyle: 'ph2'
      },
      {
        field: 'name',
        header: 'Name',
        type: 'text',
        style: 'ph2',
        fieldStyle: 'ph2',
        childClass: 'pointer underline',
        onClick: (e, props) => Dispatch.nextState('view.details.selected', props.id)
      },
    ],
    data: (props) => props.shipmentTypes?.rawData ?? [],
    loading: (props) => props.shipmentTypes?.loading ?? true,
    details: ShipmentTypeDetails,
    header: SaveHeader,
  }
}

const GenericTable = (props) => {
  const table = tables[props.view?.details?.table]
  const title = table?.title ?? ''
  const data = table?.data(props) ?? []
  const layout = table?.layout ?? []
  const loading = table?.loading(props) ?? true
  const selected = props.view?.details?.selected ?? false
  const Header = table?.header ?? ((props) => { return <div></div>})
  const locationType = table?.locationType
  const type = table?.type
  const Details = table?.details ?? ((props) => {return <div></div>})

  return (
    <div key={selected} className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='f6 white' icon={faTruck} />
          <div className='pl2 fw7 f6 white'>{title}</div>
          <div className='h2'></div>
        </div>
        <Header _type={type} _locationType={locationType} {...props}/>
      </div>
      {selected && <Details {...props}/>}
      <div className='w-100 flex' style={{background: '#f5f3f5'}}>
        <Table _tableName={'genericTable'} _shipments={data} _loading={loading} _columnLayout={layout} {...props}/>
      </div>
    </div>
  )
}

export default GenericTable